import React from 'react'
import { SettingsType } from 'models/SettingsType'

import CenteredLoader from '../../components/view/CenteredLoader'
import { useClickOutside } from '../../hooks/useClickOutside'

import { ModalBody, ModalChildrenContainer } from './Modal.style'

interface Props {
  onClose: () => void
  isLoading?: boolean
  isMobile?: boolean
  isMaximized?: boolean
  settings?: SettingsType
}

const Modal: React.FC<Props> = props => {
  const ref = useClickOutside(props.onClose)

  return (
    <ModalBody
      data-test='modal'
    >
      {props.isLoading ? (
        <CenteredLoader position={'relative'} size={48} borderTopColor={props.settings?.color}/>
      ) : (
        <ModalChildrenContainer
          data-test='modal-content'
          ref={ref}
        >
          {props.children}
        </ModalChildrenContainer>
      )}
    </ModalBody>
  )
}

export default Modal
